

export enum KeysTypeMetadataForm {
    JobId = 'JobId',
    JobDescription = 'JobDescription',
    JobNumber = 'JobNumber',
    JobDueDate = 'JobDueDate',
    JobStartDate = 'JobStartDate',
    JobCompletedDate = 'JobCompletedDate',
    JobCustomer = 'JobCustomer',
    JobSiteAddress = 'JobSiteAddress',
    JobSitePlaceId = 'JobSitePlaceId',
    JobOwner = 'JobOwner',
    JobPriority = 'JobPriority',
    JobStatus = 'JobStatus',
    JobType = 'JobType',
    JobCustomFields = 'JobCustomFields',
    JobWorkOrders = 'JobWorkOrders',
    /** Every stage's lines on the job, flattened — the Job-merged twin of WorkOrderCodes (WBS-11249). */
    JobCodes = 'JobCodes',
    WorkOrderNumber = 'WorkOrderNumber',
    WorkOrderDueDate = 'WorkOrderDueDate',
    WorkOrderStartDate = 'WorkOrderStartDate',
    WorkOrderCompletedDate = 'WorkOrderStartDate',
    WorkOrderTechnician = 'WorkOrderTechnician',
    WorkOrderTechnicianABN = 'WorkOrderTechnicianABN',
    WorkOrderTechnicianPhone = 'WorkOrderTechnicianPhone',
    WorkOrderTechnicianEmail = 'WorkOrderTechnicianEmail',
    WorkOrderResources = 'WorkOrderResources',
    WorkOrderName = 'WorkOrderName',
    WorkOrderStatus = 'WorkOrderStatus',
    WorkOrderCodes = 'WorkOrderCodes',
    WorkOrderCustomFields = 'WorkOrderCustomFields',
    AssetCustomFields = 'AssetCustomFields',


    QuoteDescription = 'QuoteDescription',
    QuoteNumber = 'QuoteNumber',
    QuoteDueDate = 'QuoteDueDate',
    QuoteApprovalDate = 'QuoteApprovalDate',
    QuoteCustomer = 'QuoteCustomer',
    QuoteSiteAddress = 'QuoteSiteAddress',
    QuoteOwner = 'QuoteOwner',

    QuoteStatus = 'QuoteStatus',
    QuoteType = 'QuoteType',
    QuoteCodes = 'QuoteCodes',
}